import Settings from '../../../../settings/Settings';
import Enemy from '../../enemy/Enemy';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    TINT: 0xffffff,
    SIZE: 30,
    OFFSET_X: 20,
    OFFSET_Y: -3,
};

type EnemyHp = {
    current: number;
    max: number;
};

export default class Health extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private bar!: Phaser.GameObjects.Image;
    private nameText!: Phaser.GameObjects.BitmapText;
    private hp!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = 300;
        super(scene, x, y);

        this.setupBG();
        this.setupBar();
        this.setupName();
        this.setupHP();

        this.setupListeners();
    }

    setupBG() {
        let frame = 'gui/health/bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    setupBar() {
        let x = -this.bg.displayWidth / 2;
        let y = 0;
        let frame = 'gui/health/bar';

        this.bar = this.scene.add.image(x, y, 'atlas', frame);
        this.bar.setOrigin(0, 0.5);
        this.add(this.bar);
    }

    setupName() {
        let x = -this.bg.displayWidth / 2 + LABEL.OFFSET_X;
        let y = LABEL.OFFSET_Y;

        this.nameText = this.scene.add.bitmapText(x, y, LABEL.FONT, 'Monster', LABEL.SIZE);
        this.nameText.setOrigin(0, 0.5);
        this.nameText.setTint(LABEL.TINT);
        this.add(this.nameText);
    }

    setupHP() {
        let x = this.bg.displayWidth / 2 - LABEL.OFFSET_X;
        let y = LABEL.OFFSET_Y;

        this.hp = this.scene.add.bitmapText(x, y, LABEL.FONT, '100 HP', LABEL.SIZE);
        this.hp.setOrigin(1, 0.5);
        this.hp.setTint(LABEL.TINT);
        this.add(this.hp);
    }

    setupListeners() {
        this.scene.events.on(Enemy.EVENTS.SPAWNED, this.onEnemySpawned, this);
        this.scene.events.on(Enemy.EVENTS.HEALTH_UPDATED, this.update, this);
    }

    onEnemySpawned(name: string, hp: EnemyHp) {
        this.nameText.setText(name);
        this.update(hp);
    }

    update(hp: EnemyHp) {
        let width = (this.bg.displayWidth * hp.current) / hp.max;
        this.bar.setCrop(0, 0, width, this.bar.displayHeight);

        this.hp.setText(`${hp.current} HP`);
    }

    destroy() {
        this.scene.events.off(Enemy.EVENTS.SPAWNED, this.onEnemySpawned, this);
        this.scene.events.off(Enemy.EVENTS.HEALTH_UPDATED, this.update, this);
        super.destroy();
    }
}
